export class PopupData {
    public isVisible: boolean = false;
    public title!: string;
    public message!: string;
}